<!--
@name  tableOperation
@author ying
@date   2022-10-14
@desc   公用table操作
-->
<template>
  <div class="table-operation flex-box" v-if="selectionList.length > 0">
    <div class="selected-box">
      已选中<span class="selected-num">{{selectionList.length}}项</span>
    </div>
    <div class="btnbox flex-box">
      <div 
        class="btn-text flex-box" 
        :class="{ 'disabled': item.disabled }"
        v-for="(item, key) in btnList" 
        :key="key" 
        @click="($event)=>btnClickHandle(item, $event)">
        <el-icon v-if="item.icon && item.icon.includes('el')"><component :is="item.icon" /></el-icon>
        <i v-if="item.icon && item.icon.includes('hhgw')" :class="item.icon"></i>
        <div>{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'table-operation',
  props: {
    btnList: { // 按钮组
      type: Array,
      default: () => []
    },
    selectionList: { // 选中数据
      type: Array,
      default: () => []
    }
  },
  created () {
  },
  methods: {
    btnClickHandle (item, $event) { // 点击事件抛出
      this.$emit('tableBtnClick', item, $event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/table.scss';

.btn-text.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>